import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import News from "./News";

const standardPanel = (contentVariable) => {
  return (
    <Row>
      <Col xs={0} md={1}>
      </Col>
      <Col className="content-background">{contentVariable}</Col>
      <Col xs={0} md={1}>
      </Col>
    </Row>
  );
};

const Home = () => {
  const componentContent = (
    <div>
      <h2>
        Vibe - Advanced RL Operations Platform
      </h2>
      <p>
        Vibe is a specialized platform designed for reinforcement learning engineers and researchers,
        streamlining the process of experimenting with and deploying RL algorithms. Built by RL engineers
        for RL engineers, Vibe provides a robust infrastructure for training, testing, and deploying
        reinforcement learning models.
      </p>
      <p>
        <strong>NEW:</strong> Vibe now supports distributed training with SAC agents, enabling 
        unprecedented scalability for reinforcement learning workloads! 
        <Link to="/news" className="ml-2">Learn more →</Link>
      </p>
      <p>
        Supported algorithms:
        • StableBaselines3 PPO (Proximal Policy Optimization)
        • RLlib DQN (Deep Q-Network)
        • RLlib Distributed SAC (Soft Actor-Critic) - NEW!
      </p>
      <p>
        <a href="https://vibe.astartech.ai/" target="_blank" rel="noopener noreferrer" 
           className="btn btn-primary">Access Vibe Platform</a>
      </p>
    </div>
  );
  return standardPanel(componentContent);
};

const AboutUs = () => {
  const componentContent = (
    <div>
      <h2>About Us</h2>
      <p>
        A* Technologies is built by a team of reinforcement learning engineers and researchers
        who understand the challenges of implementing and scaling RL systems. We've experienced
        firsthand the complexity of setting up RL environments, managing experiments, and
        deploying models to production.
      </p>
      <p>
        With Vibe, we're addressing the critical gaps in the RL development workflow, providing
        tools that we wished we had when working on complex RL projects. Our platform streamlines
        the experimentation process while maintaining the flexibility that RL engineers need.
      </p>
    </div>
  );
  return standardPanel(componentContent);
};

const Industries = () => {
  const componentContent = (
    <div>
      <h2>Technical Features</h2>
      <p>
        Vibe provides a comprehensive suite of tools for RL development and experimentation:
      </p>
      <h3>Core Capabilities</h3>
      <p>
        • <strong>NEW: Distributed SAC</strong>: Scale Soft Actor-Critic training across multiple machines
        • Integrated Algorithms: Pre-configured environments for StableBaselines3 PPO and RLlib DQN
        • Experiment Management: Version control for hyperparameters, models, and environments
        • Environment Wrapper: Standardized interface for custom environment integration
        • Distributed Training: Scale your training across multiple machines
        • Metrics Tracking: Comprehensive logging of training metrics and model performance
      </p>
      <h3>Latest Advancement: Distributed SAC Agent</h3>
      <p>
        Our newest feature enables distributed training with Soft Actor-Critic (SAC) agents,
        a significant advancement for complex reinforcement learning tasks. This implementation:
      </p>
      <ul>
        <li>Leverages multiple GPUs and machines for parallel experience collection</li>
        <li>Maintains stable learning dynamics even at high scales</li>
        <li>Automatically manages synchronization and gradient aggregation</li>
        <li>Provides seamless integration with existing Vibe workflow</li>
      </ul>
      <h3>Development Workflow</h3>
      <p>
        • Quick Start Templates: Begin with pre-configured algorithm implementations
        • Custom Environment Support: Easy integration of your own RL environments
        • Hyperparameter Optimization: Structured experimentation with different configurations
        • Model Versioning: Track and compare different versions of your models
        • Deployment Pipeline: Streamlined path to production for trained models
      </p>

      <h3>Vibe in Action</h3>
      <p>
        Below is a demonstration of Vibe's capabilities. Watch how 
        reinforcement learning models are trained and deployed using 
        our streamlined, production-ready approach.
      </p>

      <div className="video-container">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/hvibDjXgw-M"
          title="YouTube video: A* Technologies Vibe Demo"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
  return standardPanel(componentContent);
};

const Contact = () => {
  const componentContent = (
    <div>
      <h2>Get Started with Vibe</h2>
      <p>
        Ready to streamline your RL development workflow? 
        Access the platform at: <a href="https://vibe.astartech.ai/" target="_blank" 
        rel="noopener noreferrer">https://vibe.astartech.ai/</a>
      </p>
      <p>
        For technical support or inquiries:
        contact[at]astartech.ai
      </p>
      <p>
        Join our community of RL engineers and researchers building the next generation
        of reinforcement learning applications.
      </p>
    </div>
  );
  return standardPanel(componentContent);
};

function App() {
  return (
    <Switch>
      <Route exact path="/">
        <Home />
      </Route>
      <Route path="/about">
        <AboutUs />
      </Route>
      <Route path="/industries">
        <Industries />
      </Route>
      <Route path="/contact">
        <Contact />
      </Route>
      <Route path="/news">
        <News />
      </Route>
    </Switch>
  );
}

export default App;